import AlertViewModal from "./AlertViewModal";

export default AlertViewModal;
